/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { EmergencyAlertPlanControllerService } from './services/emergency-alert-plan-controller.service';
import { NewsletterControllerService } from './services/newsletter-controller.service';
import { ReportTemplateControllerService } from './services/report-template-controller.service';
import { CustomersDocumentsTemplatesControllerService } from './services/customers-documents-templates-controller.service';
import { InitialLetterControllerService } from './services/initial-letter-controller.service';
import { CustomerOverviewExportControllerService } from './services/customer-overview-export-controller.service';
import { FieldOfCareControllerService } from './services/field-of-care-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    EmergencyAlertPlanControllerService,
    NewsletterControllerService,
    ReportTemplateControllerService,
    CustomersDocumentsTemplatesControllerService,
    InitialLetterControllerService,
    CustomerOverviewExportControllerService,
    FieldOfCareControllerService,
    ApiConfiguration
  ],
})
export class CustomersDocumentsModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersDocumentsModule> {
    return {
      ngModule: CustomersDocumentsModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersDocumentsModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersDocumentsModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
